export const fetchSelectList = (url, callback) => {
    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
        })
        .catch(() => {
            // TODO resolve catch
        });
};

export const fetchAddPayment = (url, formData, callback) => {
    fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
        })
        .catch(() => {
            // TODO resolve catch
        });
};

export const fetchCreatePartner = (formData, callback) => {
    fetch(routable.getRoute('createCompanyPartner'), {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
        })
        .catch(() => {
            // TODO resolve catch
        });
};

export const fetchDaData = (param, callback) => {
    fetch(`${routable.getRoute('loadRequisites')}?field=${param.name}&value=${param.value}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
        })
        .catch(() => {
            // TODO resolve catch
        });
};
